import { render, staticRenderFns } from "./cadastrador.vue?vue&type=template&id=493f0058"
import script from "./cadastrador.vue?vue&type=script&lang=js"
export * from "./cadastrador.vue?vue&type=script&lang=js"
import style0 from "./cadastrador.vue?vue&type=style&index=0&id=493f0058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports